import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "AID_EDU_SSA",
  title: defineMessage({
    id: "fig.finance.aid.AID_EDU_SSA.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.AID_EDU_SSA.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.AID_EDU_SSA.source",
    defaultMessage: ``,
  }),
};
